/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/GameModes/IGameMode',[],function () {
    "use strict";

    var IGameMode = function () {
        /// <summary>
        /// Is timer enabled
        /// </summary>
        //this.TimerOption = IGameMode.TimerSettings.Off;
        /// <summary>
        /// Name of game mode can
        /// </summary>
        this.Name = null;
        /// <summary>
        /// Events happens when cards moves
        /// </summary>
        this.OnMoveCardButton = function () {};

        /// <summary>
        /// If true deal button visible on canvas
        /// </summary>
        /// <returns></returns>
        this.IsUpdateDealButtonsVisible = function () { return false; };
        /// <summary>
        /// If true draw button visible on canvas
        /// </summary>
        /// <returns></returns>
        this.IsUpdateDrawButtonVisible = function () { return false; };
        /// <summary>
        /// Inject configuration information to SolitairePage
        /// </summary>
        /// <param name="page"></param>
        this.ConfigureSolitairePage = function (page) {};

        /// <summary>
        /// Determines whether to wait for animations to complete before
        /// giving hint.
        /// </summary>
        this.WaitForAnimationOnHint = false;

        /// <summary>
        /// Creates game teamplate
        /// </summary>
        /// <returns></returns>
        this.CreateTemplate = function () { return null; };

        /// <summary>
        /// Retruns cheats moves action list
        /// </summary>
        /// <returns></returns>
        this.GetCheatMoves = function () { return null; };
        /// <summary>
        /// returns help information
        /// </summary>
        /// <returns></returns>
        this.HelpDataSource = function () { return null; };

        /// <summary>
        /// returns postions of all game buttons on the screen
        /// </summary>
        /// <returns></returns>
        this.ButtonsPosition = function (invertAxis) { return {}; };

        /// <summary>
        /// Creates proper game end for game
        /// </summary>
        /// <returns></returns>
        this.GetGameEnd = function () {
            return null;
        };

        /// <summary>
        /// Sets share values for current game
        /// </summary>
        /// <param name="args"></param>
        this.SetShare = function (args) {};

        this.UpdateLeaderBoard = function () {};

        this.GetStatKey = function() {};
    };

    IGameMode.GameButtons =
    {
        Deal: 0,
        Draw: 1
    };

    IGameMode.TimerSettings =
    {
        Off: 0,
        CountUp: 1,
        CountDown: 2
    };

    return IGameMode;

});
